import React, { useState } from 'react';
import { 
  AddCircleOutline as ExpandIcon,
  RemoveCircleOutline as CollapseIcon 
} from '@mui/icons-material';
import './styles.css';
import Typography from '@mui/material/Typography';

const FAQ = ({FaqItems,FontSize='18px'}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Función reutilizable para Typography
  const renderText = (text, isQuestion = false) => (
    <Typography 
      fontSize={FontSize}
      fontFamily={isQuestion ? '"Itaca Wide"' : '"Albert Sans", sans-serif'}
      display="inline"
      fontWeight={isQuestion ? 700 : 400}
      lineHeight='100%'
    >
      {text}
    </Typography>
  );

  

  const toggleAccordion = (index) => {
    setActiveIndex(prevIndex => prevIndex === index ? null : index);
  };

  return (

        
        <div className="faq-question-answer">
          {FaqItems.map((faq, index) => (
            <div 
              key={`faq-${index}`}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3>{renderText(faq.question, true)}</h3>
                {activeIndex === index ? (
                  <CollapseIcon className="expand-icon" aria-hidden="true" sx={{ fontSize: 16 }} />
                ) : (
                  <ExpandIcon className="expand-icon" aria-hidden="true" sx={{ fontSize: 16 }} />
                )}
              </button>
              <div 
                id={`faq-answer-${index}`}
                className="faq-answer"
                role="region"
              >
                <p>{renderText(faq.answer)}</p>
              </div>
            </div>
          ))}
        </div>
     
  );
};

export default React.memo(FAQ);